// Module
var code = "<mx-toast ng-if=\"DismissableToast.show\" level=\"{{DismissableToast.level}}\" class=\"DismissableToast\"> <mx-toast-body> <ng-transclude></ng-transclude> </mx-toast-body> <mx-toast-button> <button class=\"DismissableToast__dismiss\" aria-label=\"Close\" ng-click=\"DismissableToast.dismiss()\"> <dls-icon-close></dls-icon-close> </button> </mx-toast-button> </mx-toast> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/components/toasts/dismissableToast/dismissableToast.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;